module.exports = __webpack_public_path__ + "static/img/1.596d908.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/1.png
// module id = tJQf
// module chunks = 0